import { Component, Input } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { copyImageToClipboard } from 'src/app/utility/app.utils';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'qr-code-preview',
  templateUrl: './qr-code-preview.component.html',
  styleUrls: ['./qr-code-preview.component.scss'],
  imports: [TranslateModule, MatTooltipModule],
})
export class QrCodePreviewComponent {
  @Input() qr: SafeHtml;
  @Input() qrDataUrl: string;
  @Input() tooltip: string;
  @Input() dataCy: string;
  @Input() canCopy: boolean = true;

  constructor(
    private matSnackBar: MatSnackBar,
    private translator: TranslateService
  ) {}

  async copyQR() {
    if (!this.canCopy || !this.qrDataUrl) {
      return;
    }

    try {
      await copyImageToClipboard(this.qrDataUrl);
      this.matSnackBar.open(
        this.translator.instant('course.message.copiedToClipboard')
      );
    } catch (error) {
      this.matSnackBar.open(
        this.translator.instant('course.message.notCopiedToClipboard')
      );
    }
  }
}
